import script from "./motion-template-button.vue?vue&type=script&lang=js"
export * from "./motion-template-button.vue?vue&type=script&lang=js"

import "./motion-template-button.vue?vue&type=style&index=0&id=2ca149a7&scoped=true&lang=css"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ca149a7"]])

export default __exports__